import React, {useState} from 'react'
import { Field } from 'formik'
import { LinearProgress, TextField, Select, MenuItem, InputLabel, FormControl, FormHelperText, Button } from '@material-ui/core'
// import axios from 'axios'
import { KeyboardDatePicker } from '@material-ui/pickers';
import { myBucket } from '../services/UploadService'
import "../styles/FormPage1.css"
import axios from 'axios';
import { ApiURL } from '../constants/ApiUrl';

function FormPage1E({errors, touched, setFieldValue, values, appId}) {
    
    const [Progress1, setProgress1] = useState(0)
    const [Progress2, setProgress2] = useState(0)

    const handleDateChange = (n,val) => {
        const d = new Date();
        setFieldValue("dob1", "");
        if(val === null)
            return
        if(val.includes('_'))
            return
        if(d.getFullYear() - n.getFullYear() > 14)
            setFieldValue("dob1", n);
        else
            alert("An applicant should be atleast 15 years in age or date is invalid.")
    }
const uploadProfile = async (e) => {
  try {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    if (!["jpg", "jpeg", "bmp", "png"].includes(ext)) {
      alert("Only JPG, BMP, PNG files allowed");
      return;
    }

    const params = {
      Key: `applications/${appId}/profile1.${ext}`,
      ContentType: file.type,
    };

    // 1️⃣ Get signed URL from backend
    const res = await axios.get(
      ApiURL +
        `/api/upload/signed-url?key=${encodeURIComponent(params.Key)}&contentType=${encodeURIComponent(file.type)}`
    );
    const { url } = res.data;
    console.log("Signed URL generated: ", url);

    // 2️⃣ Upload with progress (XHR)
    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.setRequestHeader("Content-Type", file.type);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          setProgress1(percent);
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) resolve(xhr.response);
        else reject(new Error(`Upload failed with status ${xhr.status}`));
      };
      xhr.onerror = () => reject(new Error("Upload failed due to network error"));

      xhr.send(file);
    });

    // 3️⃣ Update form field with R2 public URL
    setFieldValue(
      "profile_image1",
      `https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${params.Key}`
    );
    console.log("File uploaded successfully: ", params.Key);
  } catch (e) {
    console.error("Upload error (profile):", e);
  }
};

const uploadSign = async (e) => {
  try {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    if (!["jpg", "jpeg", "bmp", "png"].includes(ext)) {
      alert("Only JPG, BMP, PNG files allowed");
      return;
    }

    const params = {
      Key: `applications/${appId}/sign1.${ext}`,
      ContentType: file.type,
    };

    // 1️⃣ Get signed URL from backend
    const res = await axios.get(
      ApiURL +
        `/api/upload/signed-url?key=${encodeURIComponent(params.Key)}&contentType=${encodeURIComponent(file.type)}`
    );
    const { url } = res.data;
    console.log("Signed URL generated: ", url);

    // 2️⃣ Upload with progress (XHR)
    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.setRequestHeader("Content-Type", file.type);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          setProgress2(percent);
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) resolve(xhr.response);
        else reject(new Error(`Upload failed with status ${xhr.status}`));
      };
      xhr.onerror = () => reject(new Error("Upload failed due to network error"));

      xhr.send(file);
    });

    // 3️⃣ Update form field with R2 public URL
    setFieldValue(
      "signature_image1",
      `https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${params.Key}`
    );
    console.log("File uploaded successfully: ", params.Key);
  } catch (e) {
    console.error("Upload error (sign):", e);
  }
};


    return (
        <div className="formFlexCon">
            <div className="formFlexSubCon">
                <div className="ctrl">
                    <Field name="name1" label="Name *" as={TextField} variant="outlined" fullWidth  error={touched.name1 && errors.name1} helperText={touched.name1 && errors.name1} />
                </div>
                {/* <Field name="dob1" label="Date of Birth *" as={TextField} variant="outlined" fullWidth  error={touched.dob1 && errors.dob1} helperText={touched.dob1 && errors.dob1} /> */}
                <div className="ctrl">
                    <FormControl fullWidth >
                        <KeyboardDatePicker margin="normal" label="Date of Birth (dd/mm/yyyy)*" value={values.dob1 !== '' ? values.dob1 : null} format="dd/MM/yyyy" onChange={handleDateChange} error={touched.dob1 && errors.dob1}/>
                        <FormHelperText error>{touched.dob1 && errors.dob1}</FormHelperText>
                    </FormControl>
                </div>
                <div className="ctrl">
                    <FormControl variant="outlined" fullWidth error={touched.gender1 && errors.gender1}>
                        <InputLabel id="genderLabel">Gender*</InputLabel>
                        <Field name="gender1" labelId="genderLabel" label="Gender*" as={Select} fullWidth >
                            <MenuItem value=''>Select Gender</MenuItem>
                            <MenuItem value='male'>Male</MenuItem>
                            <MenuItem value='female'>Female</MenuItem>
                            <MenuItem value='other'>Other</MenuItem>
                        </Field>
                        <FormHelperText error>{touched.gender1 && errors.gender1}</FormHelperText>
                    </FormControl>
                </div>
                <div className="ctrl">
                    <Button variant="contained" component="label" fullWidth>
                        Applicant Photograph
                        <input name="profile_image1" type="file" hidden onChange={uploadProfile} accept="image/*"/>
                        <FormHelperText error>{touched.profile_image1 && errors.profile_image1}</FormHelperText>
                    </Button>
                    {values.profile_image1 !== '' && <a href={values.profile_image1} target="_blank" rel="noreferrer">View Uploaded Profile Image</a>}
                    <LinearProgress variant="determinate" value={Progress1} />
                </div>
                
            </div>
            <div className="formFlexSubCon">
            <div className="ctrl">
                <FormControl variant="outlined" fullWidth error={touched.blood_group1 && errors.blood_group1}>                    
                    <InputLabel id="bgLabel">Blood Group *</InputLabel>
                    <Field name="blood_group1" labelId="bgLabel" label="Blood Group *" as={Select} fullWidth >
                        <MenuItem value="">Select blood group</MenuItem>
                        <MenuItem value="A+">A+</MenuItem>
                        <MenuItem value="A-">A-</MenuItem>
                        <MenuItem value="B+">B+</MenuItem>
                        <MenuItem value="B-">B-</MenuItem>
                        <MenuItem value="AB+">AB+</MenuItem>
                        <MenuItem value="AB-">AB-</MenuItem>
                        <MenuItem value="O+">O+</MenuItem>
                        <MenuItem value="O-">O-</MenuItem>    
                    </Field>
                    <FormHelperText error>{touched.blood_group1 && errors.blood_group1}</FormHelperText>
                </FormControl>
            </div>
            <div className="ctrl">
                <Field name="email1" label="Email *" as={TextField} variant="outlined" fullWidth  error={touched.email1 && errors.email1} helperText={touched.email1 && errors.email1} />
            </div>
            <div className="ctrl">

                <Field name="phone1" label="Mobile Number *" as={TextField} variant="outlined" fullWidth  error={touched.phone1 && errors.phone1} helperText={touched.phone1 && errors.phone1} />
            </div>
            <div className="ctrl">

                <Button variant="contained" component="label" fullWidth>
                    Applicant Signature
                    <input name="signature_image1" type="file" hidden onChange={uploadSign} accept="image/*"/>
                    <FormHelperText error>{touched.signature_image1 && errors.signature_image1}</FormHelperText>
                </Button>
                {values.signature_image1 !== '' && <a href={values.signature_image1} target="_blank" rel="noreferrer">View Uploaded Signature</a>}
                <LinearProgress variant="determinate" value={Progress2} />
            </div>
            </div>
        </div>
    )
}

export default FormPage1E
